var App;

App = require('config/app');

module.exports = App.Router.map(function() {
  this.route('documents');
  this.route('documents_new', {
    path: 'documents/new'
  });
  return this.route('document', {
    path: 'documents/:document_id'
  });
});
